import { FeatureParameterItem } from './FeatureParameterItem';
import { Dialog } from '../../../atoms/Dialog';
import { Tooltip } from '../../../atoms/Tooltip';
import type { ComparisonTableGroup } from '../types';

type Props = ComparisonTableGroup['features'][0] & {
  tooltipVariant?: 'tooltip' | 'modal';
};

export const FeatureContentItem = ({ feature, parameters, tooltipVariant = 'tooltip' }: Props) => {
  const renderTooltipContent = () => {
    if (feature.tooltipLinkText && feature.tooltipLinkUrl) {
      return (
        <p>
          {feature.tooltipLabel}{' '}
          <a href={feature.tooltipLinkUrl} target="_blank" rel="noopener noreferrer">
            {feature.tooltipLinkText}
          </a>
        </p>
      );
    }

    return <p>{feature.tooltipLabel}</p>;
  };

  const renderFeatureName = () => {
    if (!feature.tooltipLabel) {
      return <span>{feature.name}</span>;
    }

    if (tooltipVariant === 'modal') {
      // DialogRadix.Trigger wraps the children prop and makes it clickable
      // When clicked, Radix automatically manages the open/close state internally
      return (
        <Dialog title={feature.name} content={renderTooltipContent()} className="feature-explanation-modal">
          <span className="features-item-content__feature-name-with-modal">{feature.name}</span>
        </Dialog>
      );
    }

    return (
      <Tooltip content={renderTooltipContent()}>
        <span>{feature.name}</span>
      </Tooltip>
    );
  };

  return (
    <div className="features-item-content__feature">
      <div className="features-item-content__feature-name">{renderFeatureName()}</div>

      {parameters.map((item) => (
        <FeatureParameterItem key={item.id} {...item} />
      ))}
    </div>
  );
};
